import { Box, Grid, TextField, Typography } from "@mui/material"
import useTranslationSharie from "../hooks/Language/useTranslation"

const UserDetails = ({ setUserDetails }) => {
  const t = useTranslationSharie()

  return (
    <Box mb={6}>
      <Typography variant='h5' fontWeight='bold' gutterBottom>
        {t("Enter Your Details")}
      </Typography>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <TextField
            fullWidth
            label={t("Full Name")}
            variant='outlined'
            placeholder='John Doe'
            onChange={(event) => {
              setUserDetails((prevState) => ({
                ...prevState,
                full_name: event.target.value,
              }))
            }}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            fullWidth
            label={t("Email")}
            variant='outlined'
            placeholder='example@email.com'
            type='email'
            onChange={(event) => {
              setUserDetails((prevState) => ({
                ...prevState,
                email: event.target.value,
              }))
            }}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            fullWidth
            label={t("Phone Number")}
            variant='outlined'
            placeholder='050-0000000'
            type='tel'
            onChange={(event) => {
              setUserDetails((prevState) => ({
                ...prevState,
                phone: event.target.value,
              }))
            }}
          />
        </Grid>
      </Grid>
    </Box>
  )
}
export default UserDetails
